import { Controller } from "@hotwired/stimulus"
import { scrollContainerFor } from "../utils/scroll_container"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.scrollHandler = this.throttle(() => {
      this.updateVisibility()
    }, 16)

    // Capture phase: in the admin area the page scroll belongs to an element, not the document.
    window.addEventListener('scroll', this.scrollHandler, true)
  }

  disconnect() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler, true)
    }
  }

  scrollToTop() {
    scrollContainerFor(this.element).scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  updateVisibility() {
    if (!this.hasButtonTarget) return

    const scrollTop = scrollContainerFor(this.element).scrollTop

    if (scrollTop > 400) {
      this.buttonTarget.classList.add('visible')
    } else {
      this.buttonTarget.classList.remove('visible')
    }
  }

  throttle(func, limit) {
    let inThrottle
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args)
        inThrottle = true
        setTimeout(() => inThrottle = false, limit)
      }
    }
  }
}
